<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.RepliedFilter.label')"
    :placeholder="$t('components.filters.RepliedFilter.items.placeholder')"
  >
    <template v-slot:selection="{item}">
      <span
        class="filter__summary text--disabled"
      >
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from './models/SingleSelect';

export default {
  name: 'RepliedFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectItems: [
        {
          text: this.$t('components.filters.RepliedFilter.items.placeholder'),
          value: null,
        },
        {
          text: this.$t('components.filters.RepliedFilter.items.replied'),
          value: true,
        },
        {
          text: this.$t('components.filters.RepliedFilter.items.unanswered'),
          value: false,
        },
      ],
    };
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        let value;

        if (newValue !== null) {
          value = {
            value: newValue,
          };
        }

        this.$emit('input', value);
      },
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .filter__summary {
    font-size: 13.333px;
  }
</style>
